import * as React from 'react';
import matchSorter from 'match-sorter';

import { ItemBase } from './types';

// Shamelessly stolen from
// https://github.com/segmentio/evergreen/blob/master/src/avatar/src/utils/getInitials.js
export const getInitials = (name: string) => {
  return name
    .replace(/\s+/, ' ')
    .split(' ')
    .slice(0, 2)
    .map(v => v && v[0].toUpperCase())
    .join('');
};

export function defaultItemRenderer<T extends ItemBase>(selected: T) {
  return selected.label;
}

export function defaultEmptyState() {
  return (
    <div className="py-4 text-center text-gray"> No matching options </div>
  );
}

export function defaultOptionFilterFunc<T>(items: T[], inputValue: string) {
  return matchSorter(items, inputValue, { keys: ['value', 'label'] });
}
